export * from './src/locations-v1-location-locations.meta.js';
